/** Columns of the camera screen's equal grid for `n` tiles; past six it scrolls. */
export function gridColumns(n: number): number {
  if (n <= 1) return 1;
  return n <= 4 ? 2 : 3;
}
